import Mehmet from "../../assets/Pannel Members/Mehmet-Onder-Pekcan.webp";
import Emin from "../../assets/Pannel Members/Emin-Taner-Elmas.webp";
import LauraSarbu from "../../assets/Pannel Members/LauraSarbu.webp";
import Aliomur from "../../assets/Pannel Members/ali-omur.webp";
import Mihail from "../../assets/Pannel Members/Mihail.webp";
import Valasia from "../../assets/Pannel Members/valasia.webp";

import Mehmet_banner from "../../assets/Pannel Banners/mehmet_banner.webp";
import Emin_banner from "../../assets/Pannel Banners/emin_banner.webp";
import LauraSarbu_banner from "../../assets/Pannel Banners/laura_banner.webp";
import Aliomur_banner from "../../assets/Pannel Banners/aliomur_banner.webp";
import Mihail_banner from "../../assets/Pannel Banners/mihail_banner.webp";
import Valasia_banner from "../../assets/Pannel Banners/valasia_banner.webp";

export const panel_members_about = [
  {
    id: "mehmet-onder-pekcan",
    image: Mehmet,
    name: "Dr. Mehmet Onder Pekcan",
    from: "Turkey",
    about: "Prof.",
    link: "/panel/mehmet-onder-pekcan",
  },
  {
    id: "emin-taner-elmas",
    image: Emin,
    name: "Dr. Emin Taner Elmas",
    from: "Turkey",
    about: "Asst. Prof.",
    link: "/panel/emin-taner-elmas",
  },
  {
    id: "laura-gabriela-sarbu",
    image: LauraSarbu,
    name: "Dr. Laura Gabriela Sarbu",
    from: "Romania",
    about: "Assoc. Prof.",
    link: "/panel/laura-gabriela-sarbu",
  },
  {
    id: "ali-dogan-omur",
    image: Aliomur,
    name: "Dr. Ali Dogan Omur",
    from: "Turkey",
    about: "Prof.",
    link: "/panel/ali-dogan-omur",
  },
  {
    id: "mihail-lucian-birsa",
    image: Mihail,
    name: "Dr. Mihail Lucian Birsa",
    from: "Romania",
    about: "Prof.",
    link: "/panel/mihail-lucian-birsa",
  },
  {
    id: "valasia-iakovoglou",
    image: Valasia,
    name: "Dr. Valasia Iakovoglou",
    from: "Greece",
    about: "Expert",
    link: "/panel/valasia-iakovoglou",
  },
];

export const panel_members = panel_members_about;

export const mehmet_onder_pekcan_data = {
  image: Mehmet,
  name: "Dr. Mehmet Onder Pekcan",
  from: "Turkey",
  about: "Dr. Prof. Pekcan received his MS Degree in Physics at The University of Chicago in June 1971, then in May 1974, his PhD Thesis was accepted in Solid State Physics in University of Wyoming. Habilitation Thesis was accepted in Solid State Physics in 1979. He worked as Visiting Professor, in University of Toronto, Department of Chemistry, CANADA between 1981-1988. He was appointed as full Professor in Istanbul Technical University in Department of Physics, TURKEY and worked there between years of 1988-2005. He was Elected Member of Turkish Academy of Sciences (TÜBA), in January 1995. Now He is Professor at Kadir Has University, in Department of Bioinformatics and Genetics. Since 2012 he is a member of Science Academy.",
  banner: Mehmet_banner,
  link: "/panel/mehmet-onder-pekcan",
};

export const emin_taner_elmas_data = {
  image: Emin,
  name: "Dr. Emin Taner Elmas",
  from: "Turkey",
  about: "Asst. Prof. Dr. Emin Taner ELMAS, has graduated from faculty of Mechanical Engineering as B.Sc. in 1995 and then completed his M.Sc. in “Energy” at Mechanical Engineering Department of Dokuz Eylül University in İzmir, Turkey and after that he received his Ph.D. in “Thermodynamics” at Mechanical Engineering Department of Ege University, in İzmir, Turkey. He has graduated from “İzmir Atatürk Lisesi – High school” in 1991.",
  banner: Emin_banner,
  link: "/panel/emin-taner-elmas",
};

export const laura_gabriela_sarbu_data = {
  image: LauraSarbu,
  name: "Dr. Laura Gabriela Sarbu",
  from: "Romania",
  about: "Dr. Laura Gabriela SARBU is currently an Associate Professor in the Department of Chemistry at Alexandru Ioan Cuza University of Iasi, Romania. She received a Ph.D. degree in Organic Chemistry in 2015. During the Ph.D. program she joined several times the Prof. dr. Henning Hopf research team in TU Braunschweig – Germany. She has more than 55 publications in peer-review journals and published 4 books. Also, is editorial board member in several journals such as Advance in Medical and Clinical Research, Annals of Clinical and Laboratory Recerca, Chemical Glycobiology Journal, International Journal Bioorganic and Medicinal Chemistry, Journal of Biomedical Research & Environmental Sciences – Green Chemistry, Journal of Clinical Research and Reports, Journal of Molecular Biology and Drug Design, International Journal of Biochemistry and Pharmacology, International Journal of Pharmaceutical Sciences and Clinical Pharmacy.",
  banner: LauraSarbu_banner,
  link: "/panel/laura-gabriela-sarbu",
};

export const ali_dogan_omur_data = {
  image: Aliomur,
  name: "Dr. Ali Dogan Omur",
  from: "Turkey",
  about: "MDr. Ali Doğan ÖMÜR Administrative DutiesAtatürk University Veterinary Faculty Dep. of Reproduction and Artificial Insemination Yakutiye, ERZURUM. 2017 – 2017 Center Vice Director Ataturk University, Food and Livestock Application and Research Center alidoganomur@gmail.com, alidogan@atauni.edu.tr”Effect of Antioxidants on Cryopreservation of Ram Semen in and out of Breeding Season” (Selcuk University, 2011) Adviser Dr. Kenan COYAN 1-Coyan, K. Başpınar N. Bucak MN, Peker-Akalın, P.  Ataman, M.B. Omur AD Gungor, s Kucukgünay, S. Ozkalp, B. Sarıözkan, S. (2010) Influence of methionine and dithioerythritol on sperm motility, lipid peroxidation and antioxidant capacities during liquid storage of ram semen. Research in Veterinary Science, 89 (3), 426–431.",
  banner: Aliomur_banner,
  link: "/panel/ali-dogan-omur",
};

export const mihail_lucian_birsa_data = {
  image: Mihail,
  name: "Dr. Mihail Lucian Birsa",
  from: "Romania",
  about: "Dr. Mihail Lucian Birsa is currently a Professor in the Department of Chemistry at the Alexandru Ioan Cuza University of Iasi, Romania. In 2003 he was selected as a member of the Alexander von Humboldt Foundation, working with Professor Henning Hopf in TU Braunschweig – Germany. Since then numerous return fellowships were granted by the Alexander von Humboldt Foundation. He has more than 125 publications in peer-review journals and published +45 books/book chapters (John Wiley & Sons, Thieme etc). Also, is editorial board member in more than 50 journals such as Applied Sciences, Arkivoc, BioChem, Edelweiss Chemical Science Journal, Journal of Medicinal Chemistry and Drug Design, Journal of Fine Chemical Engineering, Modern Approaches in Drug Designing, Pharmaceutical Toxicology.",
  banner: Mihail_banner,
  link: "/panel/mihail-lucian-birsa",
};

export const valasia_iakovoglou_data = {
  image: Valasia,
  name: "Dr. Valasia Iakovoglou",
  from: "Greece",
  about: "Dr. Valasia Iakovoglou, an Iowa State University graduate, has over 25 years of international research and teaching experience as an Ecophysiologist/Silviculture expert. Her focus is on seedling production and ecosystem restoration/conservation, emphasizing biodiversity and climate change challenges. She has received numerous scholarships and awards and serves as an editor for over ten international journals and a reviewer for over fifteen, including the IPCC",
  banner: Valasia_banner,
  link: "/panel/valasia-iakovoglou",
};

export const epms_details_map = {
  "mehmet-onder-pekcan": mehmet_onder_pekcan_data,
  "emin-taner-elmas": emin_taner_elmas_data,
  "laura-gabriela-sarbu": laura_gabriela_sarbu_data,
  "ali-dogan-omur": ali_dogan_omur_data,
  "mihail-lucian-birsa": mihail_lucian_birsa_data,
  "valasia-iakovoglou": valasia_iakovoglou_data,
};
